import axios from "axios";
import { map, some } from "lodash-es";

export const SAGA_DELAY_SIZE = 1000;

/**
 * Axios. Creating an instance...
 * @see https://github.com/axios/axios#creating-an-instance
 */
const server = axios.create({
  headers: {
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 5000,
  withCredentials: true,
  responseType: "json",
  transformResponse: [
    (data) => {
      const { results } = JSON.parse(data);
      if (results) {
        return results;
      }
      throw new Error("Error: Response data is undefined");
    },
  ],
});

/**
 * @description Post & check result (Function which either returns a Promise as result, or any other value).
 * @see https://redux-saga.js.org/docs/api/#callfn-args
 */
export const post = (body) => {
  if (!Array.isArray(body)) {
    body = [body];
  }
  return server
    .post("/actionHandler/request", { calls: body })

    .then((response) => {
      if (!some(response.data, "success")) {
        return new Error(response.data[0]?.exception?.message);
      }
      return map(response.data, "response");
    })

    .catch((error) => new Error(error));
};

/**
 * @param {(Object, Array, Error)} resp
 * @return {boolean}
 * @description Is successful response?!
 */
export const isResponseError = (resp) => resp instanceof Error;

/**
 * @param {(Object, Array, Error)} resp
 * @description If response is unsuccessful -> throw error!
 */
export const checkResponse = (resp) => {
  if (isResponseError(resp)) {
    throw resp;
  }
  return true;
};
